
import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatDate(dateString: string): string {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
}

export function formatCurrency(amount: number, currency: string = 'INR'): string {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 2
  }).format(amount);
}

// Validate mobile number - must be exactly 10 digits starting with 6, 7, 8, or 9
export function validateMobileNumber(mobile: string): boolean {
  const mobileRegex = /^[6-9]\d{9}$/;
  return mobileRegex.test(mobile.trim());
}

// Validate email format - must contain proper @ symbol and basic email structure
export function validateEmail(email: string): boolean {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email.trim());
}

// Format mobile number input - only allow digits and limit to 10 characters
export function formatMobileInput(value: string): string {
  return value.replace(/\D/g, '').slice(0, 10);
}

// Get mobile validation error message
export function getMobileErrorMessage(mobile: string): string | null {
  if (!mobile.trim()) return "Mobile number is required";
  if (mobile.length !== 10) return "Mobile number must be exactly 10 digits";
  if (!validateMobileNumber(mobile)) return "Mobile number must start with 6, 7, 8, or 9";
  return null;
}

// Get email validation error message
export function getEmailErrorMessage(email: string): string | null {
  if (!email.trim()) return "Email is required";
  if (!validateEmail(email)) return "Please enter a valid email address";
  return null;
}

// For forms where email is only used to contact the customer (not required):
// an empty value is fine, but anything typed must still be a valid address.
export function getOptionalEmailErrorMessage(email: string): string | null {
  if (!email.trim()) return null;
  if (!validateEmail(email)) return "Please enter a valid email address";
  return null;
}
